module.exports = __webpack_public_path__ + "img/0a44f634-eaa9-4fa0-b38f-5474af3bd6a8.70ae4605.png";